import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBienLaiSelectByLopRequest } from "../../../model/request/bien-lai/IBienLaiSelectByLopRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eBienLaiViewTheoLopActionTypeIds,
  IBienLaiViewTheoLopActionTypes,
  IBienLaiViewTheoLopBaseActionTypes,
} from "../../action-types/bien-lai/IBienLaiViewTheoLopActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IBienLaiHuyTheoLopRequest } from "../../../model/request/bien-lai/IBienLaiHuyRequest";

export function* bienLaiViewTheoLopSaga(): any {
  yield takeLatest(eBienLaiViewTheoLopActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(
    eBienLaiViewTheoLopActionTypeIds.HUY_PHIEU_START,
    huyPhieuWorker,
  );
}

function* loadWorker(action: IBienLaiViewTheoLopActionTypes): any {
  const request = action.payload as IBienLaiSelectByLopRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.SelectByLop, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.LOAD_SUCCESS({
        request,
        data: res.data,
      }),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.LOAD_ERRR({
        request,
        data: res.data,
      }),
    );
  }
}

function* huyPhieuWorker(action: IBienLaiViewTheoLopActionTypes): any {
  const request =
    action.payload as IBienLaiViewTheoLopBaseActionTypes<IBienLaiHuyTheoLopRequest>;
  const res: IBaseRespone = yield call(bienLaiThuApi.HuyByLop, request.data);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.HUY_PHIEU_SUCCESS({
        request: request.request,
        data: res.data,
      }),
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.HUY_PHIEU_ERR({
        request: request.request,
        data: res.data,
      }),
    );
  }
}
